import { createRoutine } from 'redux-saga-routines';
import { action, ActionType } from 'typesafe-actions';

export const routine = createRoutine('FULL_REGISTRATION/PERSONAL_DATA');

export const SAVE = 'FULL_REGISTRATION/PERSONAL_DATA/SAVE';

export const actions = {
  save: (email: string, phone: string, firstName: string) =>
    action(SAVE, { email, phone, firstName }, { ts: Date.now() }),
};

export type Action = ActionType<typeof actions>;
